import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJob.Clone.IRequest;
type Response = Api.Core.ClaimJob.Clone.IResponse;
type Headers = Api.Core.ClaimJob.Clone.IHeaders;
const url = '/api/Claims/ClaimJob/:id/Clone';
export default async function claimJobCloneApi({ id }: { id: number }): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
